import { Bridge } from '@_shared/config';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import { InformationPopup } from '@_shared/ui/Popup';

export function LocationAccessPopup() {
	const { popLayer } = useUILayerStore();

	return (
		<InformationPopup.Container closePopup={popLayer}>
			<InformationPopup.TextContainer>
				<InformationPopup.Title>
					위치 정보 이용 약관에
					<br /> 동의해 주세요!
				</InformationPopup.Title>
				<InformationPopup.SubText>
					위치 서비스를 켜면,
					<br />내 주변 정보를 받아볼 수 있어요.
				</InformationPopup.SubText>
				<InformationPopup.Warning>
					기기의 ‘설정 &gt; 딸깍 &gt; 위치&rsquo;에서
					<br /> 위치 접근을 허용해 주세요.
				</InformationPopup.Warning>
			</InformationPopup.TextContainer>
			<InformationPopup.ButtonContainer>
				<InformationPopup.Button type="deny" onClick={popLayer}>
					나중에 할게요
				</InformationPopup.Button>
				<InformationPopup.Button
					type="confirm"
					onClick={() => {
						new Bridge().locationAccess();
					}}
				>
					설정하기
				</InformationPopup.Button>
			</InformationPopup.ButtonContainer>
		</InformationPopup.Container>
	);
}
